import React, { useRef } from 'react'
import { Input } from 'reactstrap'
import styled from 'styled-components'
import { useDashboardRedux } from '@hooks'

const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 500px;
`

const SearchIcon = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${props => (props.$isExpanded ? 'absolute' : 'relative')};
    right: ${props => (props.$isExpanded ? '12px' : '0')};
    z-index: 2;
    transition: all 0.3s ease;
    color: ${props => (props.$hasValue ? '#4eac6d' : '#666')};
`

const SearchInput = styled(Input)`
    width: ${props => (props.$isExpanded ? '100%' : '0')};
    max-width: ${props => (props.$isExpanded ? '500px' : '0')};
    padding-right: ${props => (props.$isExpanded ? '40px' : '0')};
    padding-left: ${props => (props.$isExpanded ? '16px' : '0')};
    opacity: ${props => (props.$isExpanded ? '1' : '0')};
    transition: all 0.3s ease;
    border-radius: 24px;
    border: 2px solid #e0e0e0;
    background-color: #fff;

    &:focus {
        // box-shadow: 0 0 0 0.2rem rgba(78, 172, 109, 0.15);
        border-color: #4eac6d;
        outline: none;
    }

    &::placeholder {
        color: #999;
    }
`

const MenuSearchBar = () => {
    // const [isExpanded, setIsExpanded] = useState(true)
    const isExpanded = true
    const wrapperRef = useRef(null)
    const { searchValue, setSearchValue } = useDashboardRedux()

    const handleIconClick = () => {}

    const handleInputChange = e => {
        setSearchValue(e.target.value)
    }

    const handleKeyPress = e => {}

    return (
        <SearchWrapper ref={wrapperRef}>
            <SearchInput
                type="text"
                placeholder={isExpanded ? 'Search...' : ''}
                value={searchValue}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                $isExpanded={isExpanded}
            />
            <SearchIcon $isExpanded={isExpanded} $hasValue={!!searchValue} onClick={handleIconClick}>
                <i className="bx bx-sm bx-search" />
            </SearchIcon>
        </SearchWrapper>
    )
}

export default MenuSearchBar
